const hasSubtractedAmount = paymentMethodPricing =>
  Number(paymentMethodPricing?.subtracted_amount) > 0;

export default hasSubtractedAmount;
